import React, { useState } from 'react';
import { MapPin, Calendar, Euro, Sparkles, Plane, Gift } from 'lucide-react';
import { populaireReizen } from '../populaireReizenData';

const PopulaireReizen = () => {
  const [interesse1, setInteresse1] = useState('');
  const [interesse2, setInteresse2] = useState('');
  const [interesse3, setInteresse3] = useState('');
  const [reisduur, setReisduur] = useState('');
  const [budget, setBudget] = useState('');

  const handleHiddenGemSubmit = (e) => {
    e.preventDefault();
    const interesses = [interesse1, interesse2, interesse3].filter(Boolean).join(', ');
    const message = `Hoi! Ik wil graag een Verrassings Hidden Gem reis 🎁

✨ Mijn 3 voorkeuren/interesses: ${interesses || '(nog niet ingevuld)'}
📅 Reisduur/periode: ${reisduur || '(nog niet ingevuld)'}
💰 Budget: ${budget || '(nog niet ingevuld)'}

Stel jij een verrassende reis voor mij samen?`;
    const whatsappUrl = `https://wa.me/+31624359764?text=${encodeURIComponent(message)}`;
    window.location.href = whatsappUrl;
  };
  const handleWhatsAppClick = (reis) => {
    const message = `Hoi! Ik ben geïnteresseerd in ${reis.naam} (${reis.duur}, vanaf €${reis.prijs}). Kunnen jullie meer informatie geven?`;
    const whatsappUrl = `https://wa.me/+31624359764?text=${encodeURIComponent(message)}`;
    window.location.href = whatsappUrl;
  };

  return (
    <div className="min-h-screen bg-gradient-to-b from-blue-50 via-white to-green-50">
      {/* Hero Section */}
      <section className="relative py-20 overflow-hidden">
        {/* Background Image */}
        <div 
          className="absolute inset-0 bg-cover bg-center"
          style={{ backgroundImage: 'url(https://images.unsplash.com/photo-1559827260-dc66d52bef19?ixlib=rb-4.1.0&q=85&fm=jpg&crop=entropy&cs=srgb)' }}
        >
          <div className="absolute inset-0 bg-gradient-to-br from-blue-950/85 via-blue-900/75 to-blue-800/70" />
        </div>

        <div className="relative z-10 container mx-auto px-4 text-center">
          <div className="max-w-4xl mx-auto">
            <div className="flex justify-center mb-4">
              <Sparkles className="w-16 h-16 text-yellow-400 animate-pulse" />
            </div>
            <h1 className="text-4xl sm:text-5xl lg:text-6xl font-bold text-white mb-6">
              Aanbiedingen
            </h1>
            <p className="text-lg sm:text-xl lg:text-2xl text-blue-100 max-w-3xl mx-auto">
              Onze 7 mooiste aanbiedingen van dit moment — iedere maand een nieuwe selectie.
            </p>
          </div>
        </div>
      </section>

      {/* Disclaimer */}
      <section className="pt-10 pb-4">
        <div className="container mx-auto px-4 text-center">
          <p className="text-sm italic text-gray-500">
            * Alle prijzen zijn exclusief internationale vlucht.
          </p>
        </div>
      </section>

      {/* Reizen Grid */}
      <section className="pb-16 pt-6">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 md:grid-cols-2 lg:grid-cols-3 gap-8">
            {populaireReizen.map((reis) => (
              <div
                key={reis.id}
                className="bg-white rounded-2xl shadow-lg overflow-hidden transform hover:scale-105 hover:shadow-2xl transition-all duration-300 flex flex-col"
                data-testid={`deal-card-${reis.id}`}
              >
                {/* Image */}
                <div className="relative h-56 overflow-hidden">
                  <img
                    src={reis.image_url}
                    alt={reis.naam}
                    className="w-full h-full object-cover transform hover:scale-110 transition-transform duration-500"
                  />
                  <div className="absolute top-4 right-4 bg-yellow-400 px-4 py-2 rounded-full shadow-lg">
                    <span className="text-blue-950 font-bold text-sm flex items-center gap-1">
                      <Sparkles className="w-4 h-4" />
                      Deal
                    </span>
                  </div>
                  <div className="absolute bottom-4 left-4 bg-white/95 backdrop-blur-sm px-3 py-1 rounded-full">
                    <span className="text-blue-900 font-semibold text-xs flex items-center gap-1">
                      <Calendar className="w-3.5 h-3.5" />
                      {reis.duur}
                    </span>
                  </div>
                </div>

                {/* Content */}
                <div className="p-6 flex flex-col flex-grow">
                  <h3 className="text-xl font-bold text-blue-900 mb-3 leading-snug">
                    {reis.naam}
                  </h3>

                  {/* Route */}
                  <div className="mb-4 flex-grow">
                    <div className="flex items-center gap-2 text-sm font-semibold text-gray-700 mb-2">
                      <MapPin className="w-4 h-4 text-blue-600" />
                      Route
                    </div>
                    <p className="text-sm text-gray-600 leading-relaxed">
                      {reis.route}
                    </p>
                  </div>

                  {/* Prijs */}
                  <div className="flex items-center justify-between pt-4 border-t border-gray-200 mb-4">
                    <div className="flex items-center gap-2">
                      <Euro className="w-5 h-5 text-blue-600" />
                      <div>
                        <span className="text-xs text-gray-600 uppercase tracking-wide">Vanaf</span>
                        <p className="text-2xl font-bold text-blue-600 leading-tight">
                          €{reis.prijs.toLocaleString('nl-NL')}
                          <span className="text-sm text-gray-600 font-normal"> p.p.</span>
                        </p>
                      </div>
                    </div>
                  </div>

                  {/* CTA Button */}
                  <button
                    onClick={() => handleWhatsAppClick(reis)}
                    className="w-full bg-gradient-to-r from-blue-900 to-blue-700 text-white py-3 rounded-lg font-semibold hover:from-blue-800 hover:to-blue-600 transition-all duration-300 flex items-center justify-center gap-2 group"
                    data-testid={`deal-cta-${reis.id}`}
                  >
                    <Plane className="w-5 h-5 group-hover:translate-x-1 transition-transform" />
                    Neem nu contact op
                  </button>
                </div>
              </div>
            ))}
          </div>
        </div>
      </section>

      {/* Hidden Gem Verrassings Reis */}
      <section className="py-16 bg-gradient-to-br from-blue-950 via-blue-900 to-blue-800 text-white relative overflow-hidden">
        <div className="absolute inset-0 opacity-10">
          <div className="absolute top-10 left-10 w-72 h-72 bg-yellow-300 rounded-full blur-3xl" />
          <div className="absolute bottom-10 right-10 w-96 h-96 bg-blue-400 rounded-full blur-3xl" />
        </div>

        <div className="container mx-auto px-4 relative z-10">
          <div className="max-w-3xl mx-auto">
            <div className="text-center mb-10">
              <div className="inline-flex items-center gap-2 bg-yellow-400/20 backdrop-blur-sm border border-yellow-400/40 px-4 py-2 rounded-full mb-4">
                <Gift className="w-5 h-5 text-yellow-300" />
                <span className="text-sm font-semibold text-yellow-200 uppercase tracking-wide">Verrassings Reis</span>
              </div>
              <h2 className="text-3xl md:text-5xl font-bold mb-4">
                Hidden Gem Reis
              </h2>
              <p className="text-lg md:text-xl text-blue-100">
                Geen idee waar je heen wilt? Vertel ons jouw voorkeuren en ik stel een verrassende reis samen naar een hidden gem die perfect bij jou past ✨
              </p>
              <div className="mt-6 inline-block bg-white/10 backdrop-blur-sm border border-white/20 rounded-xl px-5 py-4 text-left">
                <p className="text-sm text-blue-100 leading-relaxed">
                  <span className="font-semibold text-yellow-200">✅ Wat ik voor jou regel:</span> route, activiteiten & accommodaties.<br />
                  <span className="font-semibold text-yellow-200">✈️ Vlucht:</span> hiervoor krijg je een aanrading, maar deze boek ik niet zelf.
                </p>
              </div>
            </div>

            <form
              onSubmit={handleHiddenGemSubmit}
              className="bg-white/10 backdrop-blur-md border border-white/20 rounded-2xl p-6 md:p-10 space-y-6"
              data-testid="hidden-gem-form"
            >
              {/* 3 Interesses */}
              <div>
                <label className="block text-sm font-semibold text-yellow-200 mb-3 uppercase tracking-wide">
                  ✨ 3 Voorkeuren / Interesses
                </label>
                <div className="grid grid-cols-1 md:grid-cols-3 gap-3">
                  <input
                    type="text"
                    placeholder="Bijv. cultuur"
                    value={interesse1}
                    onChange={(e) => setInteresse1(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg bg-white/90 text-blue-950 placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                    data-testid="interest-1-input"
                  />
                  <input
                    type="text"
                    placeholder="Bijv. strand"
                    value={interesse2}
                    onChange={(e) => setInteresse2(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg bg-white/90 text-blue-950 placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                    data-testid="interest-2-input"
                  />
                  <input
                    type="text"
                    placeholder="Bijv. avontuur"
                    value={interesse3}
                    onChange={(e) => setInteresse3(e.target.value)}
                    className="w-full px-4 py-3 rounded-lg bg-white/90 text-blue-950 placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                    data-testid="interest-3-input"
                  />
                </div>
              </div>

              {/* Reisduur */}
              <div>
                <label className="block text-sm font-semibold text-yellow-200 mb-3 uppercase tracking-wide">
                  📅 Reisduur / Periode
                </label>
                <input
                  type="text"
                  placeholder="Bijv. 10 dagen in juli"
                  value={reisduur}
                  onChange={(e) => setReisduur(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg bg-white/90 text-blue-950 placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                  data-testid="reisduur-input"
                />
              </div>

              {/* Budget */}
              <div>
                <label className="block text-sm font-semibold text-yellow-200 mb-3 uppercase tracking-wide">
                  💰 Budget
                </label>
                <input
                  type="text"
                  placeholder="Bijv. €1500 p.p."
                  value={budget}
                  onChange={(e) => setBudget(e.target.value)}
                  className="w-full px-4 py-3 rounded-lg bg-white/90 text-blue-950 placeholder-blue-400 focus:outline-none focus:ring-2 focus:ring-yellow-300"
                  data-testid="budget-input"
                />
              </div>

              {/* Submit */}
              <button
                type="submit"
                className="w-full bg-gradient-to-r from-yellow-400 to-yellow-500 hover:from-yellow-300 hover:to-yellow-400 text-blue-950 py-4 rounded-lg font-bold text-lg flex items-center justify-center gap-2 transition-all duration-300 transform hover:scale-[1.02] shadow-xl"
                data-testid="hidden-gem-submit-button"
              >
                <Sparkles className="w-5 h-5" />
                Ik stel de reis samen
                <Sparkles className="w-5 h-5" />
              </button>
            </form>
          </div>
        </div>
      </section>

      {/* CTA Section */}
      <section className="py-16 bg-gradient-to-r from-blue-950 to-blue-800 text-white">
        <div className="container mx-auto px-4 text-center">
          <h2 className="text-3xl md:text-4xl font-bold mb-4">
            Niet gevonden wat je zoekt?
          </h2>
          <p className="text-xl text-blue-100 mb-8">
            We maken graag een volledig op maat gemaakt reisplan voor jou!
          </p>
          <a
            href="/rondreizen-tool"
            className="inline-block bg-white text-blue-900 px-8 py-4 rounded-lg font-bold hover:bg-blue-50 transition-all duration-300 transform hover:scale-105"
          >
            Plan Je Reis op Maat
          </a>
        </div>
      </section>
    </div>
  );
};

export default PopulaireReizen;
